import type { APComponentStyles, TDeepPartial } from '@astropay/payments-lib/dist/types';

export const paymentsLibStyles: TDeepPartial<APComponentStyles> = {
  paddingWrapper: 0,
  fontFamily: 'Matter, sans-serif',

  textColor: '#0F1514',
  fontScale: {
    xSmall: 10,
    small: 12,
    medium: 14,
    base: 18,
    large: 24,
    xLarge: 30,
  },

  primaryColor: '#0F1514',
  secondaryColor: '#F1F4F3',
  textSecondaryColor: '#0F1514',

  messages: {
    success: { textColor: '#3B8A29' },
    error: { textColor: '#A12020' },
  },

  input: {
    normal: {
      textColor: '#0F1514',
      backgroundColor: '#FFFFFF',
      hintTextColor: '#8A908F',
      placeholderTextColor: '#8A908F',
      borderColor: '#DDE0DF',
      borderRadius: 12,
      borderWidth: 2,
    },
    focus: {
      textColor: '#0F1514',
      backgroundColor: '#FFFFFF',
      hintTextColor: '#0F1514',
      placeholderTextColor: '#8A908F',
      borderColor: '#0F1514',
      borderRadius: 12,
      borderWidth: 2,
    },
    disabled: {
      textColor: '#8A908F',
      backgroundColor: '#F6F8F8',
      hintTextColor: '#B7C0BF',
      placeholderTextColor: '#B7C0BF',
      borderColor: '#E1E6E5',
      borderRadius: 12,
      borderWidth: 2,
    },
    error: {
      textColor: '#0F1514',
      backgroundColor: '#FFFFFF',
      hintTextColor: '#A12020',
      placeholderTextColor: '#8A908F',
      borderColor: '#C73636',
      borderRadius: 12,
      borderWidth: 2,
    },
  },

  button: {
    small: { borderRadius: 8 },
    medium: { borderRadius: 10 },
    large: { borderRadius: 12 },
    primary: {
      textColor: '#FFFFFF',
      backgroundColor: '#0F1514',
      borderColor: '#0F1514',
      borderWidth: 0,
    },
    secondary: {
      textColor: '#0F1514',
      backgroundColor: '#F1F4F3',
      borderColor: 'transparent',
      borderWidth: 0,
    },
    text: {
      textColor: '#0F1514',
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      borderWidth: 0,
    },
    disabled: {
      textColor: '#8A908F',
      backgroundColor: '#E1E6E5',
      borderColor: 'transparent',
      borderWidth: 0,
    },
  },

  divider: {
    color: '#ECECEA',
    variant: 'solid',
    size: 1,
  },

  card: {
    padding: 16,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#ECECEA',
    borderRadius: 16,
  },
};
